var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"mt-2 mt-lg-0",attrs:{"src":_vm.src,"alt":"Logo","height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }